<template>
  <div>
    <div class="item">
      <label class="lft">工程名称：</label>
      <label class="cnt">{{ task.enginner_name }}</label>
    </div>
    <div class="item">
      <label class="lft">检测项目：</label>
      <label class="cnt">{{ task.test_item }}</label>
    </div>
    <div class="item">
      <label class="lft">出发日期：</label>
      <label class="cnt">
        <el-date-picker
          size="small"
          value-format="yyyy-MM-dd"
          v-model="data.date"
          type="date"
          placeholder="选择日期"
        >
        </el-date-picker>
      </label>
    </div>
    <div class="item">
      <label class="lft">分配组长：</label>
      <div class="cnt">
        <el-tag
          style="margin-right: 10px"
          v-if="data.leader.id > 0"
          closable
          type="danger"
          @close="onLeaderDel()"
          >{{ data.leader.name }}</el-tag
        >
        <el-button size="small" @click="selectLeader()">选择</el-button>
      </div>
    </div>
    <div class="item">
      <label class="lft">分配组员：</label>
      <div class="cnt">
        <el-tag
          closable
          style="margin-right: 10px; margin-bottom: 5px"
          @close="onGroupDel(item.id)"
          v-for="item in data.groups"
          >{{ item.name }}</el-tag
        >
        <el-button size="small" @click="selectGroup()">选择</el-button>
      </div>
    </div>
    <div class="item">
      <label class="lft">任务备注：</label>
      <label class="cnt">
        <el-input v-model="data.remark"></el-input>
      </label>
    </div>
    <div style="margin-top: 20px">
      <el-button type="primary" style="width: 100%" @click="submitForm()"
        >确定分配</el-button
      >
    </div>
    <el-dialog
      title="选择组长"
      :append-to-body="true"
      :visible.sync="dialogUserLeader"
      width="80%"
    >
      <SelStaff ref="selLeader" @staffSelected="onLeaderSelected"></SelStaff>
    </el-dialog>
    <el-dialog
      title="选择组员"
      :append-to-body="true"
      :visible.sync="dialogUserGroup"
      width="80%"
    >
      <SelStaff ref="selGroup" @staffSelected="onGroupSelected"></SelStaff>
    </el-dialog>
  </div>
</template>
<script>
import SelStaff from "@/views/dialog/sel_staff.vue";
export default {
  name: "task_allocate",
  components: { SelStaff },
  data() {
    return {
      dialogUserLeader: false,
      dialogUserGroup: false,
      task: {},
      data: { remark: "", subtaskid: 0, leader: {}, groups: [] },
    };
  },
  methods: {
    async showInfo(id) {
      this.task = await this.$api.request.get("/task/get", {
        params: {
          id: id,
        },
      });
      this.data = await this.$api.request.get("/task/get_groupinfo", {
        params: {
          taskid: id,
        },
      });
    },
    async submitForm() {
      if (this.data.date == 0) {
        this.$api.error("请选择出发日期");
        return;
      }
      if (this.data.leader.id == 0) {
        this.$api.error("请选择组长");
        return;
      }
      if (this.data.groups.length == 0) {
        this.$api.error("请选择组员");
        return;
      }

      await this.$api.confirm("确认继续吗？");
      var memids = this.data.groups.map((f) => f.id).join(",");
      var data = await this.$api.request.post("/task/save_groupinfo", {
        date: this.data.date,
        subtaskid: this.data.subtaskid,
        leaderid: this.data.leader.id,
        memberids: memids,
        remark: this.data.remark,
      });
      this.$api.success("分配成功");
      this.$router.replace("/");
      this.$emit("onSuccess", { id: this.data.id });
    },
    selectLeader() {
      this.dialogUserLeader = true;
      this.$nextTick(() => {
        this.$refs.selLeader.showInfo("waijian", 1);
      });
    },
    onLeaderSelected(list) {
      this.dialogUserLeader = false;
      this.data.leader.id = list[0].id;
      this.data.leader.name = list[0].name;
    },
    selectGroup() {
      this.dialogUserGroup = true;
      this.$nextTick(() => {
        this.$refs.selGroup.showInfo("waijian", 2);
      });
    },
    onGroupSelected(list) {
      this.dialogUserGroup = false;
      this.data.groups = list;
    },
    onLeaderDel() {
      this.data.leader = { id: 0, name: "" };
    },
    onGroupDel(id) {
      for (var i = 0; i < this.data.groups.length; i++) {
        if (this.data.groups[i].id == id) {
          this.data.groups.splice(i, 1);
          break;
        }
      }
    },
  },
};
</script>
<style scoped>
.item {
  display: flex;
  align-items: center;
  min-height: 40px;
}
.item .lft {
  text-align: left;
  min-width: 80px;
}
.item .cnt {
  text-align: left;
}
</style>
